import React, { Component } from "react";
import "../../css/dataTables.css";
import Select from "react-select";
const optResAlloc = [
    { title: "En fecha de inicio", value: "" },
    { title: "En fecha de vencimiento", value: "" },
    { title: "Reenvió de fecha de inicio", value: "" },
    { title: "Fecha de vencimiento para atrás", value: "" },
];

const customSelectStyles = (action, editMode) => ({
    container: (base) => ({
        ...base,
        flex: 1,
        minWidth: 0
    }),
    control: (base, state) => ({
        ...base,
        height: 40,
        minHeight: 40,
        borderRadius: "0 4px 4px 0",
        borderColor: "#ced4da",
        backgroundColor: action === 2 && !editMode ? "#e9ecef" : "#fff",
        boxShadow: "none",
        cursor: state.isDisabled ? "default" : "pointer",
        "&:hover": {
            borderColor: "#ced4da"
        }
    }),
    valueContainer: (base) => ({
        ...base,
        height: 40,
        padding: "0 12px"
    }),
    singleValue: (base) => ({
        ...base,
        color: "#495057",
        fontSize: "14px"
    }),
    input: (base) => ({
        ...base,
        color: "#495057",
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: 40
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#8c959f"
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#f1f3f5" : "#fff",
        color: "#212529",
        cursor: "pointer"
    })
});

class ContentRscMasterData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
        };
    }

    updateRegularField = async ({ type = "", field = "", subfield = "", index = "", value = "", maxLength = 0 }) => {
        const { showAlert, refreshModel } = this.props;
        if (type === "text") {
            if (value && value.length > maxLength) {
                return showAlert({ type: "warning", message: `Solo se permiten ${maxLength} caracteres` });
            }
        } if (type === "number") {
            if (isNaN(value)) { return; }
            value = value.trim();
        } if (type === "checkbox") {
            value = value ? "Y" : "N";
        }

        let auxModel = Object.assign({}, this.props.model);
        if (subfield || index) {
            if (subfield && index) {
                auxModel[field][index][subfield] = value;
            } else if (subfield) {
                auxModel[field][subfield] = value;
            } else {
                auxModel[field][index] = value;
            }
        } else {
            auxModel[field] = value;
        }
        await refreshModel(auxModel);
    }

    validateRegularField = async ({ type = "text", field = "", subfield = "", index = "", value = "", target = null, maxLength = 0, minValue = "", allowNulls = true }) => {
        const { showAlert, refreshModel } = this.props;
        if (type === "text") {
            if (!allowNulls && !((value || "").trim())) {
                if (target) { try { target.focus(); } catch (e) { } }
                return showAlert({ type: "warning", message: `Ingrese un valor valido por favor` });
            }

            if (maxLength && (value || "").length > maxLength) {
                return showAlert({ type: "warning", message: `Solo se permiten ${maxLength} caracteres` });
            }
        } if (type === "number") {
            value = value + "";
            if (isNaN(value)) { return; }
            if (minValue) {
                if (allowNulls && Number(value) < Number(minValue)) {
                    return showAlert({ type: "warning", message: `El valor minimo permitido es ${minValue}` });
                } else if (!allowNulls && Number(value) <= Number(minValue)) {
                    if (target) { try { target.focus(); } catch (e) { } }
                    return showAlert({ type: "warning", message: `Ingrese un valor mayor a ${minValue}` });
                }
            }
            value = value.trim();
        }

        let auxModel = Object.assign({}, this.props.model);
        if (subfield || index) {
            if (subfield && index) {
                auxModel[field][index][subfield] = value;
            } else if (subfield) {
                auxModel[field][subfield] = value;
            } else {
                auxModel[field][index] = value;
            }
        } else {
            auxModel[field] = value;
        }
        await refreshModel(auxModel);
    }

    renderHeader = () => {
        const { action, editMode, model } = this.props;
        return (
            <div className="row">
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Recurso</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2}
                            value={model.Code || ""}
                            onChange={({ target: { value } }) => {
                                if (action === 1) {
                                    this.updateRegularField({ type: "text", field: "Code", value, maxLength: 50 });
                                    this.updateRegularField({ field: "VisCode", value });
                                }
                            }}
                            onBlur={({ target }) => this.validateRegularField({ type: "text", field: "Code", value: model.Code, target, maxLength: 50, allowNulls: false })} />
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Código de barras</span>
                                <span className="d-inline d-xl-none">Código Barras</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.CodeBar || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ type: "text", field: "CodeBar", value, maxLength: 254 })}
                            onBlur={() => this.validateRegularField({ type: "text", field: "CodeBar", value: model.CodeBar, maxLength: 254 })} />
                    </div>
                </div>

                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Descripción</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.Name || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ type: "text", field: "Name", value, maxLength: 100 })}
                            onBlur={() => this.validateRegularField({ type: "text", field: "Name", value: model.Name, maxLength: 100 })} />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Nombre extranjero</span>
                                <span className="d-inline d-xl-none">Nombre Extranjero</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.ForeignName || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ type: "text", field: "ForeignName", value, maxLength: 100 })}
                            onBlur={() => this.validateRegularField({ type: "text", field: "ForeignName", value: model.ForeignName, maxLength: 100 })} />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Tipo de recurso</span>
                                <span className="d-inline d-xl-none">Tipo recurso</span>
                            </span>
                        </div>
                        <select
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.Type || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ field: "Type", value })} >
                            <option value="M">Máquina</option>
                            <option value="L">Trabajo</option>
                            <option value="O">Otros</option>
                        </select>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Grupo de recursos</span>
                                <span className="d-inline d-xl-none">Grupo recurso</span>
                            </span>
                        </div>
                        <select
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.Group || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ field: "Group", value })} >
                            <option value={1}>Recursos</option>
                        </select>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Unidad de medida</span>
                                <span className="d-inline d-xl-none">Unidad medida</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.UnitOfMeasure || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ type: "text", field: "UnitOfMeasure", value, maxLength: 100 })}
                            onBlur={() => this.validateRegularField({ type: "text", field: "UnitOfMeasure", value: model.UnitOfMeasure, maxLength: 100 })} />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Tiempo por unidades</span>
                                <span className="d-inline d-xl-none">Tiempo Unidad</span>
                            </span>
                        </div>
                        <input
                            type="time"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.TimePerUnits || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ field: "TimePerUnits", value })} />
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">
                                <span className="d-none d-xl-inline">Unidades por periodo de tiempo</span>
                                <span className="d-inline d-xl-none">Unidades por Tiempo</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            disabled={action === 2 && !editMode}
                            value={model.UnitsPerTime || ""}
                            onChange={({ target: { value } }) => this.updateRegularField({ type: "number", field: "UnitsPerTime", value })}
                            onBlur={() => this.validateRegularField({ type: "number", field: "UnitsPerTime", value: model.UnitsPerTime })} />
                    </div>
                </div>
            </div>
        );
    }

    renderBody = () => {
        const { action, editMode, model } = this.props;
        let standatdCostTotal = 0.0;
        return (
            <div>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true" >
                            General
                        </a>
                    </div>
                </nav>

                <div className="tab-content p-3 w-100 border border-top-0 rounded-bottom">
                    <div // GENERAL
                        className="tab-pane w-100 fade show"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido" >
                        <div className="row">
                            <div className="col-12 col-xl-6">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Modo de emisión</span>
                                                    <span className="d-inline d-xl-none">Modo Emisión</span>
                                                </span>
                                            </div>
                                            <Select
                                                className="p-0 border-0"
                                                classNamePrefix="react-select"
                                                isSearchable={true}
                                                isClearable={false}
                                                isDisabled={action === 2 && !editMode}
                                                value={[
                                                    { value: "", label: "Notificación" },
                                                    { value: "M", label: "Manual" }
                                                ].find(opt => opt.value === model.Type) || null}
                                                options={[
                                                    { value: "", label: "Notificación" },
                                                    { value: "M", label: "Manual" }
                                                ]}
                                                onChange={(selected) => {
                                                    const value = selected ? selected.value : "";
                                                    this.updateRegularField({ field: "Type", value });
                                                }}
                                                placeholder="Seleccionar"
                                                noOptionsMessage={() => "Sin opciones"}
                                                menuPortalTarget={document.body}
                                                styles={customSelectStyles(action, editMode)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">
                                                    <span className="d-none d-xl-inline">Asignación de recursos</span>
                                                    <span className="d-inline d-xl-none">Asignación recursos</span>
                                                </span>
                                            </div>
                                            <Select
                                                className="p-0 border-0"
                                                classNamePrefix="react-select"
                                                isSearchable={true}
                                                isClearable={false}
                                                isDisabled={action === 2 && !editMode}
                                                name="ResAlloc"
                                                value={optResAlloc
                                                    .map(opt => ({
                                                        value: opt.value,
                                                        label: opt.title
                                                    }))
                                                    .find(opt => opt.value === model.Type) || null}
                                                options={optResAlloc.map(opt => ({
                                                    value: opt.value,
                                                    label: opt.title
                                                }))}
                                                onChange={(selected) => {
                                                    const value = selected ? selected.value : "";
                                                    this.updateRegularField({ field: "Type", value });
                                                }}
                                                placeholder="Seleccionar"
                                                noOptionsMessage={() => "Sin opciones"}
                                                menuPortalTarget={document.body}
                                                styles={customSelectStyles(action, editMode)}
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="col-12">
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold">Vinculado a artículo</span>
                                            </div>
                                            {action === 2 && !editMode ?
                                                <input  type="text"  className="form-control"/>
                                                : <button type="button" disabled="true" className="btn btn-secondary mr-2 text-center">Crear enlace</button>
                                            }
                                        </div>
                                    </div> */}

                                    <div className="col-12 h5 mt-3"> Estatus </div>
                                    <div className="col-12">
                                        <div className="input-group mb-3 flex-wrap">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text form-radio">
                                                    <input
                                                        id="cbStatusEnable"
                                                        type="radio"
                                                        disabled={action === 2 && !editMode}
                                                        checked={model.Active === "Y" && model.Inactive === "N"}
                                                        onChange={() => {
                                                            this.updateRegularField({type: "checkbox", field: "Active", value: true});
                                                            this.updateRegularField({type: "checkbox", field: "Inactive", value: false});
                                                        }} />
                                                </span>
                                            </div>
                                            <label className="form-control w-auto flex-grow-0 me-2" htmlFor="cbStatusEnable">Activo</label>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text form-radio">
                                                    <input
                                                        id="cbStatusDisable"
                                                        type="radio"
                                                        disabled={action === 2 && !editMode}
                                                        checked={model.Active === "N" && model.Inactive === "Y"}
                                                        onChange={() => {
                                                            this.updateRegularField({type: "checkbox", field: "Active", value: false});
                                                            this.updateRegularField({type: "checkbox", field: "Inactive", value: true});
                                                        }} />
                                                </span>
                                            </div>
                                            <label className="form-control w-auto flex-grow-0 me-2" htmlFor="cbStatusDisable">Inactivo</label>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text form-radio">
                                                    <input
                                                        id="cbStatusAdvance"
                                                        type="radio"
                                                        disabled={action === 2 && !editMode}
                                                        checked={model.Active === "Y" && model.Inactive === "Y"}
                                                        onChange={() => {
                                                            this.updateRegularField({type: "checkbox", field: "Active", value: true});
                                                            this.updateRegularField({type: "checkbox", field: "Inactive", value: true});
                                                        }} />
                                                </span>
                                            </div>
                                            <label className="form-control w-auto flex-grow-0" htmlFor="cbStatusAdvance">Avanzado</label>
                                        </div>
                                    </div>

                                    {model.Active === "Y" &&
                                        <>
                                            {model.Inactive === "Y" && <div className="col-12 h6 mt-3"> Ambito Activo </div> }
                                            <div className="col-12 col-lg-6">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Desde</span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.ActiveFrom}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "date", field: "ActiveFrom", value})} />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-6">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Hasta</span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.ActiveTo}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "date", field: "ActiveTo", value})} />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Comentarios</span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.ActiveRemarks}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "text", field: "ActiveRemarks", value, maxLength: 30})} />
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {model.Inactive === "Y" &&
                                        <>
                                            {model.Active === "Y" && <div className="col-12 h6 mt-3"> Ambito Inactivo </div> }
                                            <div className="col-12 col-lg-6">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Desde</span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.InactiveFrom}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "date", field: "InactiveFrom", value})} />
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-6">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Hasta</span>
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.InactiveTo}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "date", field: "InactiveTo", value})} />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">Comentarios</span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled={action === 2 && !editMode}
                                                        value={model.InactiveRemarks}
                                                        onChange={({target: {value}}) => this.updateRegularField({type: "text", field: "InactiveRemarks", value, maxLength: 30})} />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-xl-6">
                                <div className="table-responsive" style={{ maxHeight: 300 }}>
                                    <table id="dataTableDocuments" className="table table-scroll">
                                        <thead className="text-center">
                                            <tr>
                                                <td className="table-header-yellow sticky-header">
                                                    <span className="d-none d-xl-inline">Costo estándar</span>
                                                    <span className="d-inline d-xl-none">Costo estándar</span>
                                                </td>
                                                <td className="table-header-yellow sticky-header">
                                                    <span className="d-none d-xl-inline">Costo estándar predeterminado</span>
                                                    <span className="d-inline d-xl-none">Estándar Predeterminado</span>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {model.Costs.map((cost, index) => {
                                                standatdCostTotal += Number(cost || 0);
                                                return (
                                                    <tr>
                                                        <td key={`standardCost-${index}`} className={`dt-row-${!(index % 2) ? "primary" : "secondary"}`}>
                                                            {`Costo estándar ${index + 1}`}
                                                        </td>
                                                        <td key={`standardCostValue-${index}`} className={`dt-row-${!(index % 2) ? "primary" : "secondary"}-light text-right`}>
                                                            {action === 2 && !editMode ?
                                                                cost
                                                                : <input
                                                                    className="form-control text-right" 
                                                                    value={cost || ""}
                                                                    onChange={({ target: { value } }) => this.updateRegularField({ type: "number", field: "Costs", index: index + "", value })} />
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            <tr>
                                                <td className={`sticky-last-row dt-row-${11 % 2 ? "primary" : "secondary"}`}>Costo estándar total</td>
                                                <td className={`sticky-last-row dt-row-${11 % 2 ? "primary" : "secondary"}-light text-right`}> {Number(standatdCostTotal || 0).toFixed(2)} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter = () => {
        // const { action, model } = this.props;
        // const { editMode } = this.state;
        return (<></>);
    }

    render() {
        const { render } = this.props;

        switch (render) {
            case "header": return this.renderHeader();
            case "body": return this.renderBody();
            case "footer": return this.renderFooter();
            default: return "";
        }
    }
}

export default ContentRscMasterData;